<template>
    <component :is="homeComponent"></component> <!-- v-bind="currentProperties" -->
</template>

<script>
    import mathLessonsPage from '~/views/math/math-lessons-page';
    import juniorHomePage from '~/views/junior/junior-home-page';
    import authByCodeCard from '~/components/auth-by-code-card';

    export default {
        name: 'home-page',
        computed: {
            homeComponent() {
                let isAuth = this.$store.state.auth.token;

                if (!isAuth) {
                    return authByCodeCard;
                }

                return (appConfig.cabinet == 'math') ? mathLessonsPage : juniorHomePage;
            }
        }
    }
</script>